export enum AdLevelFields {
  impressions = 'impressions',
  frequency = 'frequency',
  reach = 'reach',
}

export enum SupportType {
  Conversions = 'conversions',
  Revenue = 'revenue',
}

export enum StageType {
  estimate = 'estimate',
  conversion = 'conversion',
  revenue = 'revenue',
}
